import { FormControlLabel, FormControlLabelProps, FormHelperText, Switch, SwitchProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface Props extends Omit<FormControlLabelProps, 'control' | 'onChange' | 'value'> {
  name: string;
  helperText?: React.ReactNode;
  color?: SwitchProps['color']; // ensure correct theme type
}

export function RHFSwitch({ name, helperText, color, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <FormControlLabel control={<Switch {...field} checked={field.value} color={color} />} {...other} />
          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
          )}
        </div>
      )}
    />
  );
}
